import { useMemo } from "react"
import { renderSVG } from "uqr"
import { cn } from "@/lib/utils"

type Scene3dFlyQrProps = {
  url: string
  label: string
  className?: string
}

/** Compact client-side QR for phone-fly deep-link (desktop header). */
export function Scene3dFlyQr({ url, label, className }: Scene3dFlyQrProps) {
  const svg = useMemo(
    () =>
      renderSVG(url, {
        ecc: "M",
        border: 1,
        whiteColor: "#ffffff",
        blackColor: "#111111",
      }),
    [url],
  )

  return (
    <div
      role="img"
      aria-label={label}
      title={label}
      className={cn(
        "h-[5.25rem] w-[5.25rem] shrink-0 overflow-hidden rounded-md bg-white p-0.5 [&_svg]:h-full [&_svg]:w-full",
        className,
      )}
      // uqr SVG output for our deep-link URL only.
      dangerouslySetInnerHTML={{ __html: svg }}
    />
  )
}
